import { createFileRoute } from '@tanstack/react-router'
import EditionProductionPlan from 'Edition/components/sections/General/EditionProductionPlan/EditionProductionPlan'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-schedule')({
    component: EditionProductionPlan,
})
